import styled from 'styled-components/macro'

const SpinnerContainer = styled.div`
  position: relative;
  display: block;
  margin-left 20px;
  margin-right: 4px;
  margin-top: 2px;
  align-self: start;
`

export default SpinnerContainer
